module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-s-denim.737a58d5.svg";